module.exports = __webpack_public_path__ + "media/logos/dark_rectangle-4a04960e.png";